export default __webpack_public_path__ + "static/media/affirmation.71a9cbb1.svg";